export default "__VITE_ASSET__Bw_xxV1s__"